import { contentAi } from '@mi-front/api-clients';

export function isSocialOperationInProgress(data: contentAi.ContentGetQueryResponse) {
  if (!data) {
    return false;
  }

  return Boolean(data.socialVersions.versions.find((v) => v.generation.status === 'IN_PROGRESS'));
}
